import React from 'react';
import { useDesign } from '../../design/DesignContext';
import AdaMark from '../../design/AdaMark';
import AmbientSky from '../../design/ambient/AmbientSky';
import { CONDITION_LABELS } from '../../design/ambient/weather';
import { PLACES, PLACE_STORAGE_KEY, toPlaceOverride } from '../../design/places';
import AuthenticationComponent from '../Authentication';

export default function LoginScreen({ onLogin, onError, onDevLogin }) {
  const { todWindow, location, weather, condition, setPlaceOverride, cycleModePref, resolvedMode, ambient, setAmbient } = useDesign();
  const greeting = ['night', 'dusk', 'golden'].includes(todWindow) ? 'Good evening' : ['dawn', 'morning'].includes(todWindow) ? 'Good morning' : 'Good afternoon';
  const city = location?.city || 'San Francisco';
  const changeCity = (event) => {
    const place = PLACES.find(p => p.id === event.target.value);
    if (!place) return;
    setPlaceOverride(toPlaceOverride(place));
    try { localStorage.setItem(PLACE_STORAGE_KEY, place.id); } catch { /* session only */ }
  };
  return (
    <main className="ada-entry">
      <AmbientSky variant="login" />
      <header className="ada-entry__header">
        <a className="ada-entry__brand" href="/" aria-label="Ada home"><AdaMark />ada<span>by Container Labs</span></a>
        <button className="ada-entry__mode" onClick={cycleModePref} aria-label={`Appearance: ${resolvedMode}. Change appearance`}>{resolvedMode === 'dark' ? '◐' : '◑'}</button>
      </header>
      <div className="ada-entry__body">
        <section className="ada-entry__intro">
          <p className="ada-entry__eyebrow">A LITTLE CURIOSITY. A LOT OF POSSIBILITY.</p>
          <h1>A mind of her own.<br /><span>On your side.</span></h1>
          <p className="ada-entry__description">Room to think. The nerve to try.<br />Meet Ada, your partner in what comes next.</p>
          <div className="ada-entry__scene-note"><span />{greeting}{location?.city ? `, ${city}` : ''}.<br /><small>Your world, a little more in view.</small></div>
        </section>
        <section className="ada-entry__card" aria-labelledby="ada-signin-title">
          <AdaMark className="ada-entry__mark" />
          <p className="ada-entry__eyebrow">YOUR SPACE TO THINK</p>
          <h2 id="ada-signin-title">Come on in.</h2>
          <p>Pick up a thought.<br />Or start something entirely new.</p>
          <div className="ada-entry__auth"><AuthenticationComponent onLogin={onLogin} onError={onError} onDevLogin={onDevLogin} /></div>
          <div className="ada-entry__privacy"><svg width="14" height="16" viewBox="0 0 20 22" aria-hidden="true"><path d="M4 9V6a6 6 0 0112 0v3M3 9h14v11H3Z" fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>We do not train on your data</div>
          <p className="ada-entry__terms">By continuing, you agree to our <a href="/terms">Terms</a><br />and acknowledge our <a href="/privacy">Privacy Notice</a>.</p>
        </section>
      </div>
      <footer className="ada-entry__footer">
        <a href="https://containerlabs.io">← Container Labs</a>
        <div className="ada-entry__weather"><span className="ada-entry__live" />
          <label><span className="ada-sr-only">Your sky's city</span><select aria-label="Your sky's city" value={PLACES.find(p => p.label === city)?.id || ''} onChange={changeCity}>{!PLACES.some(p => p.label === city) && <option value="">{city}</option>}{PLACES.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}</select></label>
          <span>{[weather.tempC != null && `${Math.round(weather.tempC)}°C`, CONDITION_LABELS[condition]].filter(Boolean).join(' · ')}</span>
          <button onClick={() => setAmbient(!ambient)} aria-pressed={ambient} title="Toggle ambient sky">{ambient ? 'Sky is live' : 'Sky paused'}</button>
        </div>
      </footer>
    </main>
  );
}
